export const ALGOLIA_CLIENT = "6be0576ff61c053d5f9a3225e2a90f76";

export const MOVIE_NAME = "Govinda Govinda";

export const dayCount = 4;
